import axios from 'axios'
import { getToken, logout, restoreOriginalSession, isImpersonating, getSessionHomePath } from './auth'


const urls = {
  'url': (process.env.REACT_APP_HUB_API_URL || '').replace('/amei.cloud', ''),
  'whith-amei-cloud': process.env.REACT_APP_HUB_API_URL,
  'whatsapp': process.env.REACT_APP_WHATSAPP_SERVICE_API,
}

export const api = axios.create({
  baseURL: urls['whith-amei-cloud'],
})

export const apiSimple = axios.create({
  baseURL: urls['url'],
})

export const apiWhatsapp = axios.create({
  baseURL: urls['whatsapp'],
})

apiSimple.interceptors.request.use(async (config) => {
  const token = getToken()

  config.headers['unic-request'] = `${new Date()} - ${Math.random()}`

  if (token) config.headers.Authorization = `${token}`

  return config
})

api.interceptors.request.use(async (config) => {
  const token = getToken()

  config.headers['unic-request'] = `${new Date()} - ${Math.random()}`

  if (token) config.headers.Authorization = `${token}`

  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error?.response?.status === 403 &&
      error?.response?.data?.friendly_message === 'Token expirado.'
    ) {
      if (isImpersonating() && restoreOriginalSession()) {
        window.location = getSessionHomePath()
        return
      }

      logout()
      window.location = '/'
    } else {
      return Promise.reject(error)
    }
  },
)


export default api
